import React from 'react';
import SEO from '../components/SEO';

const Cookies: React.FC = () => {
  return (
    <>
      <SEO
        title="Cookie Policy - GameObsidian"
        description="Learn about how GameObsidian uses cookies and similar technologies to enhance your browsing experience."
        url="/cookies"
      />

      <div className="min-h-screen pt-20 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-6xl font-bold mb-8">
            Cookie <span className="text-gradient">Policy</span>
          </h1>
          <p className="text-dark-muted mb-8">Last updated: December 2025</p>

          <div className="glass-effect rounded-2xl p-8 space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">1. What Are Cookies?</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                Cookies are small text files that are placed on your computer or mobile device when 
                you visit a website. They are widely used to make websites work more efficiently 
                and provide information to the website owners.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. How We Use Cookies</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                GameObsidian uses cookies for the following purposes:
              </p>
              <ul className="list-disc list-inside text-dark-muted space-y-2 mb-4">
                <li>To remember your preferences and settings</li>
                <li>To analyze website traffic and usage patterns</li>
                <li>To improve website functionality and user experience</li>
                <li>To provide personalized content and advertisements</li>
                <li>To track the effectiveness of our marketing campaigns</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Types of Cookies We Use</h2>
              
              <h3 className="text-xl font-semibold mb-2">3.1 Essential Cookies</h3>
              <p className="text-dark-muted leading-relaxed mb-4">
                These cookies are necessary for the website to function properly. They enable core 
                functionality such as security, network management, and accessibility.
              </p>

              <h3 className="text-xl font-semibold mb-2">3.2 Analytics Cookies</h3>
              <p className="text-dark-muted leading-relaxed mb-4">
                These cookies help us understand how visitors interact with our website by collecting 
                and reporting information anonymously. This helps us improve our website's performance.
              </p>

              <h3 className="text-xl font-semibold mb-2">3.3 Marketing Cookies</h3>
              <p className="text-dark-muted leading-relaxed mb-4">
                These cookies are used to track visitors across websites to display relevant 
                advertisements. They may also be used to limit the number of times you see an ad.
              </p>

              <h3 className="text-xl font-semibold mb-2">3.4 Preference Cookies</h3>
              <p className="text-dark-muted leading-relaxed mb-4">
                These cookies allow our website to remember information that changes the way the 
                website behaves or looks, such as your preferred language or region.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Third-Party Cookies</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                In addition to our own cookies, we may also use various third-party cookies to 
                report usage statistics, deliver advertisements, and provide enhanced functionality. 
                These third parties may set their own cookies on your device.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Managing Cookies</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                You have the right to accept or reject cookies. Most web browsers automatically 
                accept cookies, but you can usually modify your browser settings to decline cookies 
                if you prefer. However, this may prevent you from taking full advantage of our website.
              </p>
              <p className="text-dark-muted leading-relaxed mb-4">
                You can manage your cookie preferences through:
              </p>
              <ul className="list-disc list-inside text-dark-muted space-y-2 mb-4">
                <li>Your browser settings</li>
                <li>Our cookie consent banner</li>
                <li>Third-party opt-out tools</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Cookie Duration</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                Cookies may be either "persistent" or "session" cookies. Persistent cookies remain 
                on your device for a set period or until you delete them, while session cookies 
                are deleted when you close your browser.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">7. Updates to This Policy</h2>
              <p className="text-dark-muted leading-relaxed mb-4">
                We may update this Cookie Policy from time to time to reflect changes in our 
                practices or for other operational, legal, or regulatory reasons. Please review 
                this page periodically for any updates.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">8. Contact Us</h2>
              <p className="text-dark-muted leading-relaxed">
                If you have any questions about our use of cookies, please contact us at:{' '}
                <a
                  href="mailto:privacy@gameobsidian.com"
                  className="text-accent-primary hover:text-accent-secondary transition-colors"
                >
                  privacy@gameobsidian.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cookies;

